import { Divider } from "@mui/material";
import { Link } from "react-router-dom";
import smallSlateDigitalLogoPath from "../assets/slate-digital-logo-small.svg";
import slateDigitalLogoPath from "../assets/slate-digital-logo.svg";
import smallVirtuLogoPath from "../assets/virtu-logo-small.svg";
import virtuLogoPath from "../assets/virtu-logo.svg";

export default function Branding() {
    return (
        <Link
            to="/"
            style={{
                marginRight: "20px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                alignItems: "center",
                textDecoration: "none",
            }}
        >
            <h1>
                <picture>
                    <source
                        media="(max-width:899px)"
                        srcSet={smallVirtuLogoPath}
                    />
                    <img
                        src={virtuLogoPath}
                        alt="Virtu - Assisted Mastering by Slate Digital"
                        style={{ height: "19px" }}
                    />
                </picture>
            </h1>

            <Divider orientation="vertical" variant="fullWidth" />

            <picture>
                <source
                    media="(max-width:899px)"
                    srcSet={smallSlateDigitalLogoPath}
                />
                <img
                    src={slateDigitalLogoPath}
                    alt="Slate Digital's logo"
                    style={{ height: "36px" }}
                />
            </picture>
        </Link>
    );
}
